<script setup lang="ts">
import { BadgeCheck } from 'lucide-vue-next'

import PanelGroup from '../../PanelGroup.vue'
import AudienceToggleCard from './AudienceToggleCard.vue'
import { useEditorLoyaltyData, type AudiencePreviewRule } from '../../../composables/editorLoyaltyData'

const { t } = useI18n()
const { customerStatus, audiences, audiencePreviewRule } = useEditorLoyaltyData()

const togglePreview = (rule: AudiencePreviewRule) => {
  audiencePreviewRule.value = audiencePreviewRule.value === rule ? null : rule
}

const isStatusEnabled = computed({
  get: () => customerStatus.value.isEnabled,
  set: (value: boolean) => {
    customerStatus.value = { ...customerStatus.value, isEnabled: value }
  }
})

const statusAudienceIds = computed({
  get: () => customerStatus.value.audienceIds,
  set: (value: number[]) => {
    customerStatus.value = { ...customerStatus.value, audienceIds: value }
  }
})
</script>

<template>
  <PanelGroup>
    <div class="flex flex-col gap-3">
      <AudienceToggleCard
        id="brandApp.customerStatus.isEnabled"
        v-model:enabled="isStatusEnabled"
        v-model:audience-ids="statusAudienceIds"
        :icon="BadgeCheck"
        :is-previewing="audiencePreviewRule === 'status'"
        :audiences="audiences"
        :label="t('pages.loyaltySupports.webapp.editor.audience.statusLabel')"
        :description="t('pages.loyaltySupports.webapp.editor.audience.statusDescription')"
        :empty-error="t('pages.loyaltySupports.webapp.editor.audience.statusEmptyError')"
        @toggle-preview="togglePreview('status')"
      />
    </div>
  </PanelGroup>
</template>
